import { v1ApiClient } from '@/services';

export const duplicateChart = async (alias: string): Promise<ChartItem> => {
  const res = await v1ApiClient.post(`/charts/${alias}/duplicate`);
  return res.data;
};
